import React from 'react';
import { z } from 'zod';
import BLOCKS from '../../Packages/blocks';
import { buildBlockComponent, buildBlockConfigurationDictionary, buildBlockConfigurationSchema, } from '../../Packages/document-core';
import ColumnsContainerEditor from '../blocks/ColumnsContainer/ColumnsContainerEditor';
import ColumnsContainerPropsSchema from '../blocks/ColumnsContainer/ColumnsContainerPropsSchema';
import ContainerEditor from '../blocks/Container/ContainerEditor';
import ContainerPropsSchema from '../blocks/Container/ContainerPropsSchema';
import EmailLayoutEditor from '../blocks/EmailLayout/EmailLayoutEditor';
import EmailLayoutPropsSchema from '../blocks/EmailLayout/EmailLayoutPropsSchema';
import EditorBlockWrapper from '../blocks/helpers/block-wrappers/EditorBlockWrapper';
const EDITOR_DICTIONARY = buildBlockConfigurationDictionary(Object.assign({ Container: {
        schema: ContainerPropsSchema,
        Component: (props) => (React.createElement(EditorBlockWrapper, null,
            React.createElement(ContainerEditor, Object.assign({}, props)))),
    }, ColumnsContainer: {
        schema: ColumnsContainerPropsSchema,
        Component: (props) => (React.createElement(EditorBlockWrapper, null,
            React.createElement(ColumnsContainerEditor, Object.assign({}, props)))),
    }, EmailLayout: {
        schema: EmailLayoutPropsSchema,
        Component: (p) => React.createElement(EmailLayoutEditor, Object.assign({}, p)),
    } }, BLOCKS
    .filter((b) => !['ColumnsContainer', 'Container', 'EmailLayout'].includes(b.type))
    .reduce((acc, b) => {
    acc[b.type] = {
        schema: b.schema,
        Component: (props) => (React.createElement(EditorBlockWrapper, null, React.createElement(b.Component, props)))
    };
    return acc;
}, {})));
export const EditorBlock = buildBlockComponent(EDITOR_DICTIONARY);
export const EditorBlockSchema = buildBlockConfigurationSchema(EDITOR_DICTIONARY);
export const EditorConfigurationSchema = z.record(z.string(), EditorBlockSchema);
//# sourceMappingURL=core.js.map